import './App.css';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import routing from './Routes';
function App() {
  const isLogin = false;
  return (
    <div style={{height:'100%'}}>
      <BrowserRouter>
         <ToastContainer position='top-center' /> 
        {routing()}
      </BrowserRouter>
    </div>
  );
}

export default App;
